export const babylonLogo = require("../assets/img/BabylonJS_Logo_Small.png");
export const close = require("../assets/img/close.png");
export const fullscreen = require("../assets/img/fullscreen.png");
export const helpCircle = require("../assets/img/help-circle.png");
export const loading = require("../assets/img/spinner.png");
export const staticLoading = require("../assets/img/loading.png");
